import type { TelemetryEvent } from '@ms/yammer-telemetry';
import { isAnalyticsV2Event } from '@ms/yammer-telemetry';
import { getIsBackgroundLoad } from '@ms/yammer-telemetry-support';

export type AddIsBackgroundLoadToTelemetryEvent = (event: TelemetryEvent) => Promise<TelemetryEvent>;
export const addIsBackgroundLoadToTelemetryEvent: AddIsBackgroundLoadToTelemetryEvent = async (event) => {
  if (isAnalyticsV2Event(event)) {
    return event;
  }

  return {
    ...event,
    properties: {
      ...event.properties,
      isBackgroundLoad: getIsBackgroundLoad(),
    },
  };
};
